/**
 * Created by andrey on 7/18/17.
 */

cleverapps.Audio = function () {
    if (WebViewAudioEngine.IsApplicable()) {
        cc.sys.isWebViewAudio = true;
        this.engine = new WebViewAudioEngine();
    } else {
        this.engine = new HowlerAudioEngine();
    }

    this.disk = undefined;
    this.muted = false;
    this.windowBlurred = false;
    this.engineMuted = false;
    this.startPlaying = {};

    this.checkPlatformControls();
    this.checkWindowFocus();

    if (engine === "creator") {
        connector.platform.on("pause", this.pause.bind(this));
        connector.platform.on("resume", this.resume.bind(this));
    }
};

cleverapps.Audio.prototype.pause = function () {
    this.onChangeMusic();

    for (const url in this.startPlaying) {
        for (const spriteKey in this.startPlaying[url]) {
            const spriteName = spriteKey || undefined;
            if (this.engine.isPlaying(url, spriteName)) {
                this.engine.stopSound(url, spriteName);
            }
        }
    }

    this.startPlaying = {};
};

cleverapps.Audio.prototype.resume = function () {
    this.onChangeMusic();
};

cleverapps.Audio.prototype.checkPlatformControls = function () {
    if (connector.platform.hasAudioControls) {
        const update = function (isEnabled) {
            if (isEnabled) {
                this.unmute();
            } else {
                this.mute();
            }
        }.bind(this);
        connector.platform.on("audioToggle", update);
        update(connector.platform.isAudioEnabled);
    }
};

cleverapps.Audio.prototype.insertDisk = function (disk) {
    this.eject();

    this.disk = disk;
    this.onChangeMusic();
};

cleverapps.Audio.prototype.eject = function () {
    this.stopFadeTimeout();

    if (this.disk) {
        this.disk = undefined;
        this.onChangeMusic();
    }
};

cleverapps.Audio.prototype.mute = function () {
    if (this.muted || cleverapps.gameModes.noMute || connector.platform.oneOf(connector.INSTANT) && connector.info.os === cc.sys.OS_IOS && connector.info.isInApp) {
        return;
    }

    console.log("Audio mute");

    this.muted = true;
    this.onChangeMusic();
    this.updateMute();
};

cleverapps.Audio.prototype.unmute = function () {
    if (!this.muted || cleverapps.gameModes.noMute || connector.platform.oneOf(connector.INSTANT) && connector.info.os === cc.sys.OS_IOS && connector.info.isInApp) {
        return;
    }

    console.log("Audio unmute");

    this.muted = false;
    this.onChangeMusic();
    this.updateMute();
};

// A blurred window and the platform's own mute are independent sources of silence, so the engine
// is only unmuted once neither of them wants it.
cleverapps.Audio.prototype.updateMute = function () {
    const muted = this.muted || this.windowBlurred;
    if (this.engineMuted === muted) {
        return;
    }
    this.engineMuted = muted;

    if (muted) {
        this.engine.mute();
    } else {
        this.engine.unmute();
    }
};

// Switching to another application keeps the page visible, so connector never sends pause and the
// music plays on into the desktop. The music is paused rather than the game - a game pause would
// run GameManager.resume on the way back, and that shows a preroll ad.
cleverapps.Audio.prototype.checkWindowFocus = function () {
    connector.platform.on("windowBlur", this.setWindowBlurred.bind(this, true));
    connector.platform.on("windowFocus", this.setWindowBlurred.bind(this, false));
};

cleverapps.Audio.prototype.setWindowBlurred = function (windowBlurred) {
    if (this.windowBlurred === windowBlurred || cleverapps.gameModes.noMute) {
        return;
    }

    this.windowBlurred = windowBlurred;
    this.updateMute();

    if (windowBlurred) {
        this.engine.pauseMusic();
    } else if (!this.canPlayMusic() || !this.engine.resumeMusic()) {
        // music turned off or the disk changed while the window was away - nothing to resume,
        // onChangeMusic stops or restarts it as the current state asks
        this.onChangeMusic();
    }
};

// the hidden page is checked next to the game pause: pause arrives through page events that can
// come out of order, and a disk started into a background tab keeps playing there
cleverapps.Audio.prototype.canPlayMusic = function () {
    return this.disk && !this.muted && !this.windowBlurred && !connector.platform.isPageHidden() && cleverapps.settings.music && !cc.game.isPaused();
};

cleverapps.Audio.prototype.onChangeMusic = function () {
    if (!this.canPlayMusic()) {
        this.engine.stopMusic();
        return;
    }

    this.logSound(this.disk.resolve());
    this.engine.playMusic(this.disk.resolve().getUrl());
};

cleverapps.Audio.prototype.onSoundsLoaded = function (sounds) {
    if (this.disk && sounds.map((sound) => sound.getUrl()).includes(this.disk.resolve().getUrl())) {
        this.onChangeMusic();
    }
};

cleverapps.Audio.prototype.fadeOut = function (duration) {
    this.fade(duration, 1, 0);
};

cleverapps.Audio.prototype.fadeOutAndEject = function (duration) {
    this.fade(duration, 1, 0, () => {
        this.eject();
    });
};

cleverapps.Audio.prototype.fadeIn = function (duration) {
    this.fade(duration, 0, 1);
};

cleverapps.Audio.prototype.fade = function (duration, from, to, callback) {
    if (!this.disk) {
        return;
    }

    duration = duration || 0;

    this.engine.fade(duration, from, to);

    this.stopFadeTimeout();
    if (callback) {
        this.fadeTimeout = cleverapps.timeouts.setTimeout(callback, duration * 1000);
    }
};

cleverapps.Audio.prototype.stopFadeTimeout = function () {
    if (this.fadeTimeout) {
        cleverapps.timeouts.clearTimeout(this.fadeTimeout);
        this.fadeTimeout = undefined;
    }
};

cleverapps.Audio.prototype.playSound = function (soundRes, options) {
    if (!cleverapps.settings.sound || !soundRes || cc.game.isPaused() || this.muted || this.windowBlurred || !this.engine.isAudioContextRunning()) {
        return;
    }

    const resolvedRes = soundRes.resolve();

    if (!resolvedRes) {
        return;
    }

    options = options || {};
    this.logSound(resolvedRes, options);

    const throttle = options.throttle !== undefined ? options.throttle : cleverapps.Audio.THROTTLE_AUDIO;

    const url = resolvedRes.getUrl();
    const spriteName = resolvedRes instanceof SoundFrame ? resolvedRes.getFrameName() : undefined;

    const startPlaying = this.startPlaying[url] && this.startPlaying[url][spriteName || ""] || 0;
    if (this.engine.isPlaying(url, spriteName) && startPlaying + throttle > Date.now()) {
        return;
    }

    if (!this.engine.isLoaded(url) && resolvedRes.isLazy()) {
        cc.loader.load(resolvedRes);
        return;
    }

    this.startPlaying[url] = this.startPlaying[url] || {};
    this.startPlaying[url][spriteName || ""] = Date.now();
    this.engine.playSound(url, spriteName, options);

    return { url, spriteName };
};

cleverapps.Audio.prototype.stopSound = function (sound) {
    let url, spriteName;

    if (sound instanceof VirtualResource) {
        sound = sound.resolve();
        url = sound && sound.getUrl();
        spriteName = sound instanceof SoundFrame ? sound.getFrameName() : undefined;
    } else if (sound) {
        url = sound.url;
        spriteName = sound.spriteName;
    }

    if (!url) {
        return;
    }

    this.engine.stopSound(url, spriteName);
};

cleverapps.Audio.prototype.resumeAudioContext = function () {
    // music requested while the context was suspended was not played - start the disk the game is
    // on now, which is not necessarily the one that asked back then
    this.engine.resumeAudioContext(this.onChangeMusic.bind(this));
};

cleverapps.Audio.prototype.unload = function (url) {
    this.engine.unload(url);
};

cleverapps.Audio.THROTTLE_AUDIO = 250;

cleverapps.Audio.prototype.logSound = function (sound, options) {
    if (cleverapps.config.debugMode && cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.p)) {
        console.log("--------------------- sound logging ----------------------");
        console.log("sound file", sound.originalPath());
        if (options) {
            console.log("sound", sound.key, "options", options);
        }
        console.log("----------------------------------------------------------");
    }
};
